import React from "react";

import DownloadPdfButton from "../utils/DownloadPdfButton";
import { IPetItemResponse } from "../../../../services/Standard-of-care/standard-of-care.interface";
import { IRabiesVaccination } from "../../../../services/medical-history/medical-history.interface";
import { MIXPANEL_EVENTS } from "../../../../config/mixPanelEvents";
import RabiesDoseItem from "./RabiesDoseItem";
import { sortByAdministeredDesc } from "./rabiesCertificate.utils";
import { useRabiesCertificatePdf } from "../../../../services/medical-history/medical-history.service";

type Props = {
  petData: IPetItemResponse;
  vaccinations: IRabiesVaccination[];
};

const RabiesCertificateData = (props: Props) => {
  const { petData, vaccinations } = props;
  const sorted = sortByAdministeredDesc(vaccinations);
  const { fetchRabiesCertificatePdf } = useRabiesCertificatePdf();

  return (
    <div className="flex flex-col w-full">
      <div className="flex flex-col max-h-[31.25rem] overflow-y-auto pr-1 divide-y divide-taupe-50">
        {sorted.map((vaccination, index) => (
          <div
            key={`${vaccination.administeredAt ?? "na"}-${index}`}
            className="py-3 first:pt-0 last:pb-0"
          >
            <RabiesDoseItem vaccination={vaccination} isLatest={index === 0} />
          </div>
        ))}
      </div>

      <div className="sticky bottom-0 flex flex-col gap-3 pt-3 bg-white">
        <DownloadPdfButton
          id="downloadRabiesCertificateButton"
          label="Download Rabies Certificate"
          mixpanelEvent={MIXPANEL_EVENTS.RABIES_CERTIFICATE}
          petName={petData.name}
          errorMessage="We couldn't prepare the rabies certificate right now. Please try again."
          fetchPdf={() => fetchRabiesCertificatePdf(petData.id)}
        />
        <p className="geograph-regular text-[12px] leading-[12px] text-light-black">
          You’ll only download the newest active certificate.
        </p>
      </div>
    </div>
  );
};

export default RabiesCertificateData;
